/**
 * Created by Administrador on 16/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('makerList', {
                parent: 'app',
                url: '/maker/list',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/aircraft/maker/makers.html',
                        controller: 'makerCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAircrafts('makerList')
                            }],
                            'makers': ['makerService', '$stateParams', function (makerService, $stateParams) {
                                return makerService.getPageMakers($stateParams.page, $stateParams.size);
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['maker']);
                            }]
                        }
                    }
                }
            })
            .state('makerNew', {
                parent: 'app',
                url: '/maker/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/aircraft/maker/newMaker.html',
                        controller: 'newMakerCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAircrafts('makerList')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['maker']);
                            }]
                        }
                    }
                }
            })
            .state('makerEdit', {
                parent: 'app',
                url: '/maker/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/aircraft/maker/editMaker.html',
                        controller: 'editMakerCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAircrafts('makerList')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['maker']);
                            }],
                            'maker' : ['makerService','$stateParams', function(makerService, $stateParams){
                                return makerService.getMaker($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('makerDelete', {
                parent: 'makerList',
                url: '/maker/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/aircraft/maker/deleteMaker.html',
                        controller: 'deleteMakerCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            makerId: [function () {
                                return $stateParams.id
                            }],
                            maker: ['makerService', function (makerService) {
                                return makerService.getMaker($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['maker']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('makerList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
